// extracted by mini-css-extract-plugin
export default {"searchSection":"BoardSearch_searchSection__S6g1I"};